import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ShieldCheck } from "lucide-react";
import { CreditAuditPanel } from "@/components/integrity/CreditAuditPanel";
import { PayrollAuditPanel } from "@/components/integrity/PayrollAuditPanel";
import { CorrectionLogPanel } from "@/components/integrity/CorrectionLogPanel";

export default function AdminDataIntegrity() {
  return (
    <div className="space-y-6" data-testid="data-integrity-page">
      <div className="flex items-start gap-3">
        <div className="p-2.5 rounded-xl bg-emerald-50 text-emerald-700"><ShieldCheck className="w-6 h-6" /></div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Data Integrity Audit</h1>
          <p className="text-sm text-slate-500 max-w-3xl">
            Scans every student and tutor for wrong credit balances and payroll counts. This is report-only:
            nothing changes until you review an account and click <strong>Apply correction</strong>. Every correction is logged.
          </p>
        </div>
      </div>
      <Tabs defaultValue="credits">
        <TabsList>
          <TabsTrigger value="credits" data-testid="tab-credits">Student Credits</TabsTrigger>
          <TabsTrigger value="payroll" data-testid="tab-payroll">Payroll</TabsTrigger>
          <TabsTrigger value="log" data-testid="tab-log">Correction Log</TabsTrigger>
        </TabsList>
        <TabsContent value="credits"><CreditAuditPanel /></TabsContent>
        <TabsContent value="payroll"><PayrollAuditPanel /></TabsContent>
        <TabsContent value="log"><CorrectionLogPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
